import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isEmpty from "../validations/is-empty";

dayjs.extend(utc);
dayjs.extend(timezone);

const getHourAndMinute = (date) => {
  const timezone = isEmpty(localStorage.getItem("timezoneMode"))
    ? "Europe/London"
    : localStorage.getItem("timezoneMode");

  const d = dayjs(date).tz(timezone); // Use dayjs to handle the date with the specified timezone
  let hours = d.hour();
  const minutes = String(d.minute()).padStart(2, "0"); // Ensure minutes are two digits

  // Determine AM/PM
  const amPm = hours >= 12 ? "pm" : "am";

  // Convert 24-hour format to 12-hour format
  hours = hours % 12 || 12; // Converts 0 to 12 for midnight

  return `${hours}:${minutes}${amPm}`;
};

export default getHourAndMinute;
